<template>
  <VaLayout
    :top="{ fixed: true, order: 2 }"
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="isSidebarMinimized = true"
  >
    <template #top>
      <AppNavbar :is-mobile="isMobile" />
    </template>

    <template #left>
      <AppSidebar :minimized="isSidebarMinimized" :animated="!isMobile" :mobile="isMobile" @show="showProfile = true" />
    </template>

    <template #content>
      <div :class="{ minimized: isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
      </div>
      <AppLayoutNavigation v-if="!isMobile" class="p-4" />
      <main class="p-4 pt-0">
        <article>
          <RouterView />
        </article>
      </main>
    </template>
  </VaLayout>
  <!-- App Loading -->
  <Loading v-if="isLoading" />

  <VaModal v-model="showProfile" hide-default-actions size="400px" close-button blur no-dismiss>
    <div class="mt-4">
      <UpdatePassword @close="closeUpdatePassword" />
    </div>
  </VaModal>

  <VaModal v-model="openQuotation" hide-default-actions size="medium" close-button blur no-dismiss @close="() => {}">
    <div class="mt-4">
      <NewOportunity @close="() => {}" />
    </div>
  </VaModal>

  <VaModal v-model="openContract" hide-default-actions size="700px" close-button blur no-dismiss @close="() => {}">
    <div class="mt-4">
      <NewContract @close="() => {}" />
    </div>
  </VaModal>

  <VaModal v-model="openCompany" hide-default-actions size="340px" close-button blur no-dismiss @close="() => {}">
    <div class="mt-4">
      <NewCompany @close="() => {}" />
    </div>
  </VaModal>

  <VaModal v-model="openContact" hide-default-actions size="medium" close-button blur no-dismiss @close="() => {}">
    <div class="mt-4">
      <NewCustomer @close="() => {}" />
    </div>
  </VaModal>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint, VaModal } from 'vuestic-ui'
import Loading from '../components/Loading.vue'

import { useGlobalStore } from '../stores/global-store'

import AppLayoutNavigation from '../components/app-layout-navigation/AppLayoutNavigation.vue'
import AppNavbar from '../components/navbar/AppNavbar.vue'
import AppSidebar from '../components/sidebar/AppSidebar.vue'
import UpdatePassword from '../components/sidebar/UpdatePassword.vue'
import NewOportunity from '../pages/oportunities/pages/NewOportunity.vue'
import NewContract from '../pages/contracts/pages/NewContract.vue'
import NewCompany from '../pages/customers/pages/NewCompany.vue'
import NewCustomer from '../pages/customers/pages/NewCustomer.vue'

const GlobalStore = useGlobalStore()

const breakpoints = useBreakpoint()

const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)

const closeUpdatePassword = () => {
  showProfile.value = false
}

const showProfile = ref(false)
const isMobile = ref(false)
const isTablet = ref(false)
const { isSidebarMinimized, openQuotation, openContract, openCompany, openContact } = storeToRefs(GlobalStore)
const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'
}

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    isSidebarMinimized.value = true
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  isSidebarMinimized.value = true
}
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}
</style>
